import templateUrl from "./submitted-payrolls.component.html"
import "./submitted-payrolls.component.less"

export const DashboardSubmittedPayrollsComponent = {
    bindings: {
        page: "<",
        dismiss: "&onDismiss",
        changePage: "&onChangePage"
    },
    templateUrl,
    controller: class DashboardSubmittedPayrollsController {
        constructor() {
            this.pageNumber = 1
        }

        $onInit() {
            this.setUpdatedPageProperties(this.page)
        }

        $onChanges(changesObj) {
            if (changesObj.page) {
                this.setUpdatedPageProperties(this.page)
            }
        }

        setUpdatedPageProperties(page) {
            this.pageNumber = page.PageIndex + 1;
            this.pageSize = page.PageSize + 1;
            this.submittedPayrolls = page.Entities;
            this.totalEntityCount = page.TotalEntityCount
        }
    },
    controllerAs: "vm"
}
